import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';

import { Button } from '../../shared/FormStyles/Button';

export const Container = styled.div`
  ${space};
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  width: 100%;
  background-color: ${themeGet('colors.white')};

  @media screen and (max-width: 1220px) {
    width: 100%;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 16px 0 0;
  ${({ lastInputHasMessage }) => lastInputHasMessage && `margin-top: 24px;`}
`;

export const ActionButton = styled(Button)`
  margin: 0;

  &:not(:last-child) {
    margin-right: 16px;
  }
`;
